import { Dispatch, createContext } from "react";
import { State, Action } from "./types";
import { reducer } from "./reducer";
import {
  createStateHook,
  createDispatchHook,
  createContextHook,
  createProvider,
} from "../../factory";
import { InsightType } from "../../../utils/routes";

export const initialState: State = {
  active: {},
  activeProject: undefined,
  insightType: InsightType.Insights,
  isLoading: false,
  pristine: true,
  isSaving: false,
  saved: {},
  selectedRule: undefined,
  shouldReset: false,
};

const stateContext = createContext<State | undefined>(undefined);
const dispatchContext = createContext<Dispatch<Action> | undefined>(undefined);

export const ConfigProvider = createProvider(
  stateContext,
  dispatchContext,
  reducer,
  initialState
);
export const useConfigState = createStateHook(stateContext);
export const useConfigDispatch = createDispatchHook(dispatchContext);
export const useConfig = createContextHook(stateContext, dispatchContext);
